import { useContext } from "react";

import { SkeletonText } from "@chakra-ui/react";

import { Text } from "../../internal/exports";

import { ContributionContext } from "../context";
import { HTMLWrapperWithoutOverrides } from "@/storybook-components/html-wrapper/html-wrapper";

export function Description() {
  const {
    cardDescription,
    isLoaded,
    showDescription,
    descriptionId,
    showFullTextContent,
    addonNode
  } = useContext(ContributionContext);

  if (!showDescription) return null;

  const noOfLines = showFullTextContent ? undefined : 2;

  if (!isLoaded) {
    return <SkeletonText mt={2} noOfLines={noOfLines} />;
  }

  if (typeof cardDescription === "object")
    return (
      <>
        <Text
          fontSize="md"
          lineHeight="6"
          id={descriptionId}
          wordBreak="break-word"
          lineClamp={noOfLines}
          whiteSpace="pre-wrap"
          data-testid="card-descriptionText"
        >
          {cardDescription}
        </Text>
        {addonNode || null}
      </>
    );

  return (
    <>
      <HTMLWrapperWithoutOverrides
        id={descriptionId}
        lineClamp={noOfLines}
        html={cardDescription as string}
        wordBreak="break-word"
        fontSize="md"
        lineHeight="1.5"
        data-testid="card-descriptionText"
        css={{
          "& p, & li, & span": { lineHeight: "1.5", fontSize: "inherit" },
          "& > ul, & > ol": { p: "revert" }
        }}
      />
      {addonNode || null}
    </>
  );
}
